/**
 * @deprecated This file is deprecated and will be removed in the future.
 * Use specific page dependency context or common dependencies from `common.ts`.
 */
export * from './DependenciesProvider';
export * from './useDependencies';
